import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data/site";

export default function Services() {
  return (
    <section
      id="usluge"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-surface border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-14 md:mb-20">
          <div className="md:col-span-7 reveal">
            <div className="text-xs uppercase tracking-widest2 text-brand flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-brand" />
              Usluge
            </div>
            <h2 className="font-display font-black text-white tracking-tightest leading-[0.95] text-4xl md:text-5xl lg:text-6xl">
              Sve elektroinstalacijske
              <br />
              <span className="text-brand">usluge</span> na jednom mjestu.
            </h2>
          </div>
          <p className="md:col-span-5 text-ink-muted leading-relaxed md:pb-3 reveal">
            U našoj ponudi nudimo širok spektar usluga iz područja
            elektroinstalacija — od planiranja i shemiranja razdjelnika do
            složenih sustava vatrodojave, gromobrana i solarnih elektrana.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              data-testid={`service-card-${i}`}
              className="group relative bg-surface hover:bg-bg transition-colors duration-500 overflow-hidden reveal"
              style={{ animationDelay: `${(i % 3) * 0.08}s` }}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  loading="lazy"
                  className="w-full h-full object-cover opacity-70 group-hover:opacity-100 zoom-img"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-bg via-bg/40 to-transparent" />
                {s.badge && (
                  <span className="absolute top-4 left-4 text-[10px] uppercase tracking-widest2 bg-brand text-white px-2.5 py-1.5">
                    {s.badge}
                  </span>
                )}
                <span className="absolute top-4 right-4 text-[10px] uppercase tracking-widest2 text-ink-muted">
                  0{i + 1}
                </span>
              </div>
              <div className="p-6 md:p-7 border-t border-white/5">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-display font-bold text-white text-xl md:text-2xl tracking-tight leading-tight">
                    {s.title}
                  </h3>
                  <ArrowUpRight
                    size={20}
                    className="slide-arrow text-ink-muted group-hover:text-brand flex-shrink-0 mt-1"
                  />
                </div>
                <p className="mt-3 text-sm text-ink-muted leading-relaxed">
                  {s.desc}
                </p>
              </div>
              <span className="absolute bottom-0 left-0 right-0 h-px bg-brand scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
